import React from 'react';
import { getTimeDifference, formatTime } from './utils';

const TimeFromCreation = React.memo(({ className, time }) => {
  const timeDiff = getTimeDifference({ firstTime: time, lastTime: new Date() });
  const timeFormatted = formatTime(timeDiff);

  return (
    <div data-testid="timeFromCreation" className={className}>
      {timeFormatted}
    </div>
  );
});

export default TimeFromCreation;
